import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import CollapseExpand from "../../../components/collapseExpandSection";
import {useStateValue} from "../../../states/StateProvider";
import ButtonMailto from "../../../helper/mailToButton";
import {ClipLoader, SkewLoader} from "react-spinners";
import {Link} from "react-router-dom";
import EditFPIcon from '../../../assets/datenänderung.png';
import ansprechpWechseln from '../../../assets/AnsprechpWechsel.png';
import SupportIcon from '../../../assets/ServiceMail.png';
import ControllerMailIcon from '../../../assets/ControllerMail.png';
import CompanyInfoPopUpDGG from "../../../components/modal/companyInfoPopUpDGG";
import {FaChevronDown, FaChevronUp} from 'react-icons/fa';
import Api from "../../../Api/api";
import CompanyInfoPopUp from "../../../components/modal/companyInfoPopUp";
import ServiceMailModal from "../../../components/modal/ServiceMailModal";
import AnsprechpartnerEditorModal from "../../newCreation/partial/AnsprechpartnerEditorModal";
import DateinachweiseBadge from "./DateinachweiseBadge";
import CompanyUpsellingBadge from "./CompanyUpsellingBadge";
import PlanunsKallenderBadge from "./PlanunsKallenderBadge";

const CompanyData = ({toggle, company, info, loading, portal, companyID, toggleEdit, user, showUpselling = true}) => {
    const [{collapse1}, dispatch] = useStateValue();
    const [{supportModalOpen}] = useStateValue();
    const [{ansprechPartnerModalOpen}] = useStateValue();
    const [{upsellingSaved}] = useStateValue();
    const [email, setEmail] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [popupInfo, setPopupInfo] = useState(null);
    const [companyInfoCache, setCompanyInfoCache] = useState({});
    const [loadingPopupInfo, setLoadingPopupInfo] = useState(false);
    const [hasUpselling, setHasUpselling] = useState(false);
    const [dataUpselling, setDataUpselling] = useState({});
    const [upsellingLoading, setUpsellingLoading] = useState(true);

    const line1 = info?.Zeile1?.replaceAll(/Tel.|\|+|Ref-Kd.|\|+|DGAPI-KAM:|\|+|Anzahl MA:|\|+|FKB:/gi, match => `<span style="color: #a1a1a1">${match} </span>`);
    const line2 = info?.Zeile2?.replaceAll(/BANK:|\|+|FKB-Bank:+|Ansprechpartner:|Regio:/gi, match => `<span style="color: #a1a1a1">${match} </span>`);
    let line3 = info?.Zeile3?.replaceAll(/BANK:|\|+|FKB-Bank:|Regio:/gi, match => `<span style="color: #a1a1a1">${match} </span>`);
    const onlyMail = line2?.replaceAll(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi, '');
    const withoutMail = onlyMail?.replaceAll(/Anspr.:|\|+| Mob.:| Email:| Tel.:/gi, match => `<span style="color: #a1a1a1">${match} </span>`);
    const Email = email?.replaceAll(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi, match => `<span style="color: #3A46A9; text-decoration: underline">${match} </span>`);
    const Web = info?.Zeile4?.replace('Link B4Y-Portal:', '');
    const statusOfCompany = info?.Status?.replace('Status:', '');

    useEffect(() => {
        if (info?.Zeile2) {
            const mail = extractEmails(info?.Zeile2);
            setEmail(mail?.[0] || 'N/A');
        }
    }, [info]);

    useEffect(() => {
        if (!companyID || !portal || portal !== 'dgg' || !showUpselling) {
            setUpsellingLoading(false);
            return;
        }

        const fetchUpselling = async () => {
            setUpsellingLoading(true);
            try {
                const res = await Api().get(`/sp_getDataCustUpselling/${portal}/${companyID}`);

                // API returns: { data: [{FP_ID, Prozess, bAV, CLS, ...}], companyName: "..." }
                const upsellingArray = res.data?.data || [];
                const upsellingObj = upsellingArray.length > 0 ? upsellingArray[0] : {};

                const hasData = upsellingObj && Object.keys(upsellingObj).length > 1;
                setHasUpselling(hasData);
                setDataUpselling(upsellingObj);
            } catch (e) {
                console.error('Error fetching upselling data:', e);
                setHasUpselling(false);
                setDataUpselling({});
            } finally {
                setUpsellingLoading(false);
            }
        };

        fetchUpselling();
    }, [portal, companyID, showUpselling, upsellingSaved]);

    function extractEmails(text) {
        return text.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi);
    }

    const handleTogglePopup = async () => {
        if (!showPopup) {
            setLoadingPopupInfo(true);
            if (!companyInfoCache[companyID]) {
                try {
                    const res = await Api().get(`/customerDetailsAll/${portal}/${companyID}`);
                    const fetchedInfo = res.data[0];
                    setCompanyInfoCache(prev => ({...prev, [companyID]: fetchedInfo}));
                    setPopupInfo(fetchedInfo);
                } catch (error) {
                    console.error("Error fetching company info:", error);
                    setPopupInfo(null);
                }
            } else {
                setPopupInfo(companyInfoCache[companyID]);
            }
            setLoadingPopupInfo(false);
            setShowPopup(true);
        } else {
            setShowPopup(false);
        }
    };

    function toggleServiceMail() {
        dispatch({type: "SET_SUPPORT_MODAL_OPEN", item: true});
    }

    function toggleAnsprechPartnerWechseln() {
        dispatch({type: "SET_ANSPRECHPARTNER_MODAL_OPEN", item: true});
    }

    const getStatusClasses = () => {
        const status = statusOfCompany?.trim().toLowerCase();
        if (status === 'abgeschlossen') {
            return 'bg-complete border-2 border-bermuda text-text p-2';
        }
        if (status === 'abgesagt') {
            return 'bg-borderRed border-2 border-cancel text-text p-2';
        }
        return '';
    };

    return (<div className='bg-white text-left text-text'>
                <div className='flex flex-row justify-between'>
                    {/* Left Column */}
                    <div className='flex-1 w-1/2 me-4'>
                        <h2 className="flex items-center text-xl p-5 text-left" style={{color: '#a1a1a1'}}>
                            {info && <Link className="me-2" target="_blank" to="/support" title="Support">
                                <img src={SupportIcon} alt="Support" className="h-5"/>
                            </Link>}
                            Firmenprojekt&nbsp;
                            <span className={`${getStatusClasses()} font-extrabold text-text`}>{company}</span>
                            {user?.role === 'Internal' && info && (<button title='Service Mail' onClick={toggleServiceMail}
                                                                           className='ps-10 flex items-center text-2xl'>
                                    <img src={ControllerMailIcon} alt="Service Mail" className='h-5'/>
                                </button>)}
                        </h2>
                        {collapse1 && (<div className="space-y-1 px-5">
                                {!info && (<div className="h-16 flex items-center justify-center">
                                        <SkewLoader size={10} color={'#6e6e6e'}/>
                                    </div>)}
                                {info && (<div className="flex items-start justify-between w-full">
                                        <div className="flex items-center">
                                            <button title="Datenänderung" onClick={toggleEdit} className="me-2">
                                                <img src={EditFPIcon} alt="Datenänderung" className="w-6 h-5"/>
                                            </button>
                                            <span dangerouslySetInnerHTML={{__html: line1}}/>
                                        </div>
                                    </div>)}
                                <div className="flex items-center">
                                    <div dangerouslySetInnerHTML={{__html: line3}}/>
                                </div>
                                {info && (<div className="flex items-center">
                                        <button
                                            title="Ansprechpartner Wechseln"
                                            onClick={toggleAnsprechPartnerWechseln}
                                            className="me-3"
                                        >
                                            <img src={ansprechpWechseln} alt="Ansprechpartner Wechseln"
                                                 className="w-5 h-5"/>
                                        </button>
                                        <span dangerouslySetInnerHTML={{__html: withoutMail}}/>
                                        <span
                                            className="cursor-pointer"
                                            onClick={() => dispatch({type: 'SET_SENDMAIL', item: true})}
                                            dangerouslySetInnerHTML={{__html: Email}}
                                        />
                                    </div>)}
                                <div className="hideDiv flex items-center">
                                    <ButtonMailto label={`Email: ${email}`} mailto={`mailto:${email}`}/>
                                </div>
                                <div className="flex items-center">
                                    <a
                                        href={Web}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{color: '#3A46A9'}}
                                        className="underline cursor-pointer"
                                    >
                                        {Web}
                                    </a>
                                </div>
                            </div>)}
                        <div className='flex justify-between items-center px-5 mt-2'>
                            <button
                                onClick={handleTogglePopup}
                                className='py-2 text-mainBlue text-xs flex items-center gap-2'
                                title="Firmendetails anzeigen"
                            >
                                {loadingPopupInfo ? <ClipLoader size={16} color={'#b4b4b4'}/> : (showPopup ?
                                    <FaChevronUp size={14}/> : <FaChevronDown size={14}/>)}
                            </button>
                        </div>
                    </div>
                    {/* Right Column */}
                    <div className='flex flex-col w-1/4 min-w-[200px]'>
                        <div className='flex flex-row w-full'>
                            {/* First column: Documents and Upselling */}
                            <div className='flex-1 flex flex-col items-start'>
                                <DateinachweiseBadge
                                    portal={portal}
                                    companyID={companyID}
                                />
                                <CompanyUpsellingBadge
                                    portal={portal}
                                    showUpselling={showUpselling}
                                    companyID={companyID}
                                    hasUpselling={hasUpselling}
                                    dataUpselling={dataUpselling}
                                    loading={upsellingLoading}
                                />
                                {/*<PlanunsKallenderBadge*/}
                                {/*    portal={portal}*/}
                                {/*    companyID={companyID}*/}
                                {/*/>*/}
                            </div>
                        </div>
                    </div>
                    {/* Second column: CollapseExpand aligned top-right */}
                    <div className='flex flex-col items-end justify-start min-w-[80px] pl-4'>
                        <CollapseExpand show={collapse1} id={1}/>
                    </div>
                </div>
                <div className='flex flex-row'>
                    <div className='flex-1 w-full'>
                        {showPopup && popupInfo && (portal === 'dgg' ? (
                            <CompanyInfoPopUpDGG portal={portal} Info={popupInfo} company={companyID}/>) : (
                            <CompanyInfoPopUp portal={portal} Info={popupInfo} company={companyID}/>))}
                        {supportModalOpen &&
                            <ServiceMailModal company={company} companyId={companyID} user={user} portal={portal}/>}
                        {ansprechPartnerModalOpen && <AnsprechpartnerEditorModal company={companyID} portal={portal}/>}
                    </div>
                </div>
            </div>
    );
};

export default CompanyData;

CompanyData.propTypes = {
    data: PropTypes.object,
    toggle: PropTypes.func,
    toggleEdit: PropTypes.func,
};
